/** "Eugene Yakovlev" -> "E. Yakovlev" (first initial + the rest of the name). One-word names stay as they are. */
export const shortName = (fullname) => {
	const parts = (fullname ?? '').trim().split(/\s+/).filter(Boolean);
	if (parts.length === 0) return '';
	if (parts.length === 1) return parts[0];
	return `${Array.from(parts[0])[0].toLocaleUpperCase()}. ${parts.slice(1).join(' ')}`;
};

/**
 * id -> display name in the short format. People whose short names collide (Eugene and Elena Yakovlev are both
 * "E. Yakovlev") keep their full name so they can be told apart.
 */
export const shortNamesDict = (namesDict) => {
	const entries = Object.entries(namesDict ?? {});
	const counts = {};
	entries.forEach(([, name]) => {
		const key = shortName(name).toLocaleLowerCase();
		counts[key] = (counts[key] ?? 0) + 1;
	});
	return Object.fromEntries(entries.map(([id, name]) => {
		const short = shortName(name);
		return [id, counts[short.toLocaleLowerCase()] > 1 ? (name ?? '').trim() : short];
	}));
};
